import { Eip712SignatureService } from '~/modules/Products/Infrastructure/Eip712SignatureService'
import { HttpCardApiService } from '~/modules/Cards/Infrastructure/HttpCardApiService'
import { HttpTrophyApiService } from '~/modules/Trophies/Infrastructure/HttpTrophyApiService'
import { SegmentAnalyticsService } from '~/modules/Analytics/Infrastructure/SegmentAnalyticsService'

/**
 * Client-side dependency injector (we cannot mix client and server imports)
 * @todo The whole dependency injection stuff needs a refactor
 */
export class DependencyInjector {
  // eslint-disable-next-line no-use-before-define
  private static instance: DependencyInjector

  public static getInstance (): DependencyInjector {
    if (!DependencyInjector.instance) {
      DependencyInjector.instance = new DependencyInjector()
    }

    return DependencyInjector.instance
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public resolve (provider: string): any {
    switch (provider) {
      case 'CardApiServiceInterface':
        return new HttpCardApiService(new SegmentAnalyticsService(window.analytics))

      case 'TrophyApiServiceInterface':
        return new HttpTrophyApiService(new SegmentAnalyticsService(window.analytics))

      case 'SignatureServiceInterface':
        return new Eip712SignatureService()

      default:
        throw new Error(`Unknown provider: ${provider}`)
    }
  }
}
